<template>
    <div class="position-relative w-100 h-100" :class="isOverlayDisplayed ? 'overflow-hidden' : 'overflow-auto'">
        
        <b-row class="h-100 w-100 m-0">
            <b-col class="h-100 w-100 p-0">
				<iframe ref="iframeCenter" 
						name="iframeCenter" 
						id="iframeCenter" 
						class="h-100 w-100 m-0 border-0 block position-absolute" 
						:style="spanResizing ? 'pointer-events: none;' : ''"
						@load="iframeLoaded()"  
						@mouseenter="sessionUtils.CheckExpirationSession($event)"
						@mouseleave="sessionUtils.CheckExpirationSession($event)">
				</iframe>
            </b-col>
        </b-row>

        <b-overlay 
            no-wrap 
            no-center 
            :show="isOverlayDisplayed" 
            :opacity="overlayOpacity"
        >
            <template #overlay>
                <Welcome v-if="displayedOverlay === overlayEnum.SingleNodeSelection" :DisplayBrand="false" :Variant="Variant">
                    <template v-slot:MiscContent>
                        <h4 class="text-center">{{ $t('PleaseSelectAnObject') }}</h4>
                    </template>
                </Welcome>
                <Welcome v-if="displayedOverlay === overlayEnum.Loading" :DisplayBrand="false" :Loading="true" :Variant="Variant" />
            </template>
        </b-overlay>

    </div>
</template>

<script lang="ts">
	import { Prop, Vue, Watch } from 'vue-property-decorator';
	import Component, { mixins } from 'vue-class-component';
	import { Getter } from 'vuex-class';
	import { DCX_SYNC_SESSION_EXPIRATION_DELAY, DCX_URL } from '@/App.settings';
	import OverlayEnum from "@/enums/OverlayEnum";
	import { OverlayUtils, SessionUtils } from '@/components/commons/Utils';
	import Welcome from '@/components/commons/Welcome.vue';
	import TreeNode from '@/types/TreeNode';
	import IFeature from '@/interfaces/IFeature';
	import locales from "./locales/IFrameLoaderFiltered.json";

	/** Composant spécifique pour affichage IFrame de fonctions V2 */
		@Component({
        components: {
            Welcome
        },
		i18n: { messages: locales }
    })
	export default class IFrameLoaderFiltered extends mixins(OverlayUtils) implements IFeature {
		/** Pour permettre l'utilisation des enums dans la section template */
		private overlayEnum = OverlayEnum;
		/** Pour vérification expériation de session */
		private sessionUtils: SessionUtils = new SessionUtils(this.$cookies, this.$router);

		/** Variant de couleurs à appliquer */
        @Prop()
        public Variant!:string;

        private singleNode!: TreeNode;

        public SetNode(node: TreeNode): Promise<any> {
            return new Promise(async (resolve, reject) => {
                this.singleNode = node;
				
				console.debug("IFrameLoaderFiltered - SetNode() - this.singleNode : ", this.singleNode);

				if (this.singleNode && Object.keys(this.singleNode).length > 0)
					this.GetFeatureInterop();
				
                resolve('SingleNode affecté !');
            });
        }

		@Getter('GetFeatureInterop')
		private interop!: string;

		/**
		 * Utilisé pour désactivre les events dans l'IFrame lorsque le splitpanes est déplacé dans Workbench.vue
					==> les events Ext.net/DCx V2 de l'IFrame interférant avec les events de DCXClient
		 */
		@Getter('GetSpanResizing')
		private spanResizing!: boolean;

		private localIframeTarget: string = "";
		private bLoadIframe: boolean = false;

		private iframeLoaded() {
			console.debug("IFrameLoaderFiltered - iframeLoaded()");
			this.hideOverlay();
		}

		@Getter('SessionStore/GetLastSync')
		private lastSync!: number; 
		
		@Watch("interop", { immediate: true })
		private async GetFeatureInterop() {
			if (this.singleNode && Object.keys(this.singleNode).length > 0) {
				this.displayOverlay(OverlayEnum.Loading);

				let ik = undefined;
				if((Date.now() - this.lastSync) > DCX_SYNC_SESSION_EXPIRATION_DELAY)
					ik = await this.$store.dispatch('SessionStore/RefreshSync');
				else
					this.$store.dispatch('SessionStore/SetSync')

				let url: string = DCX_URL + "StructManagement/" + this.interop + "_Page.aspx" + "?nodeId=" + this.singleNode.Id + "&interop=" + this.interop + (ik !== undefined ? '&lk=' + ik : '');
				url += `&_t=${new Date().getTime()}`;
				
				console.debug("IFrameLoaderFiltered - Navigation manuelle vers : " + url);

				// On récupère l'élément iframe natif
				const iframeEl = this.$refs.iframeCenter as HTMLIFrameElement;
				
				if (iframeEl && iframeEl.contentWindow) {
					// On utilise location.replace() pour ne pas polluer l'historique du navigateur
					// C'est la méthode la plus bas niveau et robuste pour forcer Chrome à charger une iframe
					iframeEl.contentWindow.location.replace(url);
				}
			}
		}

		mounted() {
			console.log("IFrameLoaderFiltered - mounted()")
			// this.$nextTick(() => {
			// 	window.addEventListener('message', (event) => {
			// 		console.group("IFrameLoaderFiltered - mounted() - 📬 Message postMessage reçu");
			// 		console.log("IFrameLoaderFiltered - mounted() - Provenance (origin):", event?.origin);
			// 		console.log("IFrameLoaderFiltered - mounted() - Données (data):", event?.data);
			// 		console.log("IFrameLoaderFiltered - mounted() - Source du message:", event?.source);
			// 		console.groupEnd();
			// 		this.hideOverlay();
			// 	});
			// });
		}

		beforeDestroy() {
			/** Nettoyage du sessionUtils */
			if (this.sessionUtils) {
				this.sessionUtils.destroy();
			}
			// On vide la variable du composant
			(this as any).sessionUtils = null;
		}
	}
</script>

<style scoped>

</style>